import SuperJSON from "superjson";
import Id from "../types/Id";

export default class ServiceAccountId extends Id<"serviceAccount"> {}

SuperJSON.registerClass(ServiceAccountId, { identifier: "ServiceAccountId" });
